import { createAsyncThunk, Dispatch } from "@reduxjs/toolkit";

import { EventAccommodationBlockService } from "Bands/services/EventAccommodationBlockService";
import { BAND_ACTIONS, IAccommodationBlockParams } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const dispatchGetEventAccommodationBlocks = (dispatch: Dispatch<any>, event?: string) => {
  dispatch(
    getEventAccommodationBlocks({
      event,
      page: 1, // we assume all blocks will be returned in page 1
      itemsPerPage: 100, // avoid pagination
    })
  );
};

export const getEventAccommodationBlocks = createAsyncThunk(
  BAND_ACTIONS.getEventAccommodationBlock,
  async (
    {
      event,
      itemsPerPage,
      page,
    }: {
      event?: string;
      page: number;
      itemsPerPage: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await EventAccommodationBlockService.getBlocks({
        event: event ? API_ENDPOINTS.EVENT(event) : undefined,
        page,
        itemsPerPage,
      });

      // keep the key even if response is empty
      return {
        [IDataKeys.eventAccommodationBlock]: data.eventAccommodationBlock,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createAccommodationBlock = createAsyncThunk(
  BAND_ACTIONS.createAccommodationBlock,
  async (block: IAccommodationBlockParams, { rejectWithValue }) => {
    try {
      const createdItem = await EventAccommodationBlockService.createBlock(block);

      const id = Object.values(createdItem?.eventAccommodationBlock)?.[0]?.attributes?.id;
      return { id, createdItem };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editAccommodationBlockTitle = createAsyncThunk(
  BAND_ACTIONS.editAccommodationBlockTitle,
  async (props: { id: string; title: string }, { rejectWithValue }) => {
    try {
      const data = await EventAccommodationBlockService.editBlockTitle(props);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editEventAccommodationBlock = createAsyncThunk(
  BAND_ACTIONS.editEventAccommodationBlock,
  async (props: { id: string; data: IAccommodationBlockParams }, { rejectWithValue }) => {
    try {
      const data = await EventAccommodationBlockService.editBlock(props);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEventAccommodationBlock = createAsyncThunk(
  BAND_ACTIONS.deleteAccommodationBlock,
  async (id: string, { rejectWithValue }) => {
    try {
      await EventAccommodationBlockService.deleteBlock(id);
      return {
        path: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(id),
        dataKey: IDataKeys.eventAccommodationBlock,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const dispatchGetEventAccommodationBlock = (dispatch: Dispatch<any>, blockId: string) => {
  const action = API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(blockId);
  return dispatch(getEventAccommodationBlock({ blockId, action }));
};

export const getEventAccommodationBlock = createAsyncThunk(
  BAND_ACTIONS.getEventAccommodationBlock,
  async ({ blockId }: { blockId: string; action: string }, { rejectWithValue }) => {
    try {
      const block = await EventAccommodationBlockService.getBlock(blockId);

      return block;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
